(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('VoceBilancioDialogController', VoceBilancioDialogController);

    VoceBilancioDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'VoceBilancio', 'Decisione'];

    function VoceBilancioDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, VoceBilancio, Decisione) {
        var vm = this;

        vm.voceBilancio = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.decisiones = Decisione.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.voceBilancio.id !== null) {
                VoceBilancio.update(vm.voceBilancio, onSaveSuccess, onSaveError);
            } else {
                VoceBilancio.save(vm.voceBilancio, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ordiniApp:voceBilancioUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataCreazione = false;
        vm.datePickerOpenStatus.dataAggiornamento = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
